<script setup lang="ts">
import { ErrorScreenLayout, SupportEmailLink } from '@Shared';
import LockedShield from '@Assets/images/locked-shield.svg';
</script>

<template>
    <div class="general-error-view">
        <div class="general-error-view__content">
            <error-screen-layout
                :image="LockedShield"
                image-alt="We were unable to secure your connection"
                title="We were unable to secure your connection"
                image-width="12rem"
                image-height="10rem">
                <p>
                    Please try again, or contact CertifID Support at <support-email-link /> or through the support chat on this page.
                </p>
            </error-screen-layout>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.general-error-view {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    @include desktop {
        padding-top: 10.25rem;
    }

    &__content {
        border-radius: 0.25rem;
        background-color: $white;
        max-width: 24.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        line-height: 150%;
        color: $black-high;
    }
}
</style>
